export const MachineStatusIotTopics = (iotThingId: string) => {
  return [
    `$aws/things/${iotThingId}/shadow/name/machine_status/get/accepted`,
    `$aws/things/${iotThingId}/shadow/name/machine_status/get/rejected`,
    `$aws/things/${iotThingId}/shadow/name/machine_status/update/accepted`
  ]
}
// note : weight scale read only
export const WeightScaleIotTopics = (iotThingId: string) => {
  return [
    `$aws/things/${iotThingId}/shadow/name/Weight_Scale/get/accepted`,
    `$aws/things/${iotThingId}/shadow/name/Weight_Scale/get/rejected`
  ]
}